export function loadAssets() {
	loadSprite("maskio", "sprites/maskio.png");
	loadSprite("vaccine", "sprites/vaccine.png");

	loadSprite("virus", "sprites/virus.png");
	loadSprite("blue-virus", "sprites/virus.png");
	loadSprite("injection", "sprites/injection.png");

	loadSprite("brick", "sprites/snow.png");
	loadSprite("blue-brick", "sprites/snow.png");

    loadSprite("block", "sprites/grass.png");
    loadSprite("blue-block", "sprites/sand.png");

	loadSprite("unboxed", "sprites/steel.png");
    loadSprite("blue-steel", "sprites/steel.png");

	loadSprite("surprise", "sprites/jumpy.png");
	loadSprite("blue-surprise", "sprites/jumpy.png");

	loadSprite("mushroom", "sprites/apple.png");
	loadSprite("portal", "sprites/portal.png");
	loadSprite("coin", "sprites/coin.png");

	loadSound("coin", "sounds/score.mp3");
	loadSound("powerup", "sounds/powerup.mp3");
	loadSound("blip", "sounds/blip.mp3");
	loadSound("hit", "sounds/hit.mp3");

	loadSound("shoot", "sounds/shoot.mp3");
	loadSound("explosion", "sounds/explode.mp3");

	loadSound("portal", "sounds/portal.mp3");
	loadSound("OtherworldlyFoe", "sounds/OtherworldlyFoe.mp3");

	loadSprite("arrow-up", "sprites/controls/arrow-circle-up-solid.svg");
	loadSprite("arrow-down", "sprites/controls/arrow-circle-down-solid.svg");
	loadSprite("arrow-left", "sprites/controls/arrow-circle-left-solid.svg");
	loadSprite("arrow-right", "sprites/controls/arrow-circle-right-solid.svg");
}
